import { Component, Input, NgModule } from '@angular/core';
import { Employee, Farm, GetUsersResponseType, Product, SendCustomerInfo } from '../../../models/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilePageService } from '../../services/profile-page.service';
import { MarketPageService } from '../../services/market-page.service';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LoginService } from '../../services/login.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-employee-details-modal',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgxCaptchaModule],
  templateUrl: './employee-details-modal.component.html',
  styleUrl: './employee-details-modal.component.scss'
})
export class EmployeeDetailsModalComponent {
  @Input() employee!: Employee;
}
